/* eslint-disable no-plusplus */
import { extentionByFileType } from 'constants/fileTypes';
import { downloadBlob } from './downloadBlob';

export const downloadBytes = async (
  fileBytes: string,
  fileName: string,
  fileType: string = ''
): Promise<void> => {
  const binaryString = atob(fileBytes);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const blob = new Blob([bytes], { type: fileType });

  let downloadFileName: string = fileName;

  if (fileType) {
    const extension =
      extentionByFileType[fileType as keyof typeof extentionByFileType];
    downloadFileName = `${fileName}.${extension}`;
  }

  await downloadBlob(blob, `${downloadFileName}`);
};
